import React, { createContext, useContext, useState } from 'react'

interface HamburgerContextInterface {
  opened: boolean
  toggleOpen: () => void
  close: () => void
}

const HamburgerContext = createContext<HamburgerContextInterface>({} as HamburgerContextInterface)

interface IProps {
  children: React.ReactNode
}

export const HamburgerProvider = ({ children }: IProps) => {
  const [opened, setOpened] = useState(false)

  return (
    <HamburgerContext.Provider
      value={{
        toggleOpen: () => setOpened((opened) => !opened),
        opened,
        close: () => setOpened(false),
      }}
    >
      {children}
    </HamburgerContext.Provider>
  )
}

export function useHamburger() {
  return useContext(HamburgerContext)
}
